import React from 'react';
import { withTranslation } from 'react-i18next';
import withRouter from 'src/config/withRouter';
import { connect } from 'react-redux';
import axios from 'axios';
import Geocode from "react-geocode";
import getIpAddress from 'src/config/GetIPAddress';
import { v4 as uuidv4 } from 'uuid';
import { save_user, set_pm, set_parentLocation, remove_user, saveParentCurrentSession, setParentTempInfo } from '../../store/action';
import firebase,{db, parentLogin, parentSignup, generateSigninOTP, sendSignupOtp, getCompanyTotalCustomers, auth } from '../../config/firebase'; //firebase
import PhoneInput, { formatPhoneNumberIntl, isValidPhoneNumber } from 'react-phone-number-input';
import withStyles from '@mui/styles/withStyles';
import { EmailOutlined, AccountCircleOutlined } from '@mui/icons-material';
import { CircularProgress, Backdrop, Checkbox } from '@mui/material';
import Alert from '@mui/material/Alert';
// component
import DotLoader from 'src/components/Utils/DotLoader';
import Input from '../custom-comp/Input';
import { EmailPhoneDialog } from './index';
import '../../assets/stylesheet/multiselect.css';
// images
import FbIcon from 'src/assets/images/parent/fb.png';
import GoogleIcon from 'src/assets/images/parent/google.png';
const CryptoJS = require("crypto-js");
// IPGEOLOCATION Credentials
const ipgeoURL = process.env.REACT_APP_IP_GEO_URL;
const ipgeoApikey = process.env.REACT_APP_IPGEO_APIKEY;
const passHashSecret = process.env.REACT_APP_LMS_PASS_HASH_SECRET;
// Email regex Pattern
const email_patt = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const StyleCheckbox = withStyles({
    root: {
      color: '#BDBDBD',
      padding:'0px 4px',
      '&$checked': {
        color: '#36abef',
      },
    },
    checked: {},
})(props => <Checkbox color="default" {...props} />);

const ColorCircularProgress = withStyles({
    root: {
      color: '#0F467A',
    },
})(CircularProgress);

const styles = theme => ({
    mainDiv:{
        width:'100%',
        borderRadius:'8px',
        display:'flex',
        flexDirection:'column',
        justifyContent:'space-around',
        alignSelf:'center',
        '& .PhoneInputInput':{
            backgroundColor: '#fff',
            border: '1px solid #ABAEB5',
            margin:'0px'
        },
        '& .PhoneInputCountrySelectArrow':{
            display:'none'
        },
        '& .PhoneInputCountryIcon--border':{
            backgroundColor:'unset',
            boxShadow:'none',
            width:'45px',
            height:'40px'
        },
        '& .PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border':{
            boxShadow:'none'
        },
        [theme.breakpoints.between('xs','md')]: {
            width:'calc(100% - 20px)'
		}
    },

    backdrop: {
        zIndex: 111125,
        color: '#fff',
    },

    inputCl:{
        width:'calc(100% - 12px)',
        padding:'5px',
        backgroundColor:'#fff',
        border:'1px solid #ABAEB5',
        borderRadius:'5px',
        fontSize:'20px',
        outline:'none'
    },

    inputClCode:{
        height:'50px',
        textAlign:'center',
        fontWeight: 500,
        fontSize:'30px',
        letterSpacing:'8px'
    },

    inputLabel:{
        color:'#000',
        fontSize:'16px',
        textTransform:'capitalize',
        fontWeight:500,
        paddingTop:'0px'
    },

    padTop:{
        paddingTop:'0px'
    },

    forgetBtn:{
        fontSize:'18px',
        color:'#0F467A',
        paddingTop:'18px',
    },

    darkSpan:{
        color: '#000',
        fontWeight: 'bold',
    },

    phoneIcon:{
        width:'50px',
        height:'50px',
        borderRadius:'50%',
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        justifyContent:'center',
        boxShadow:'2px 4px 6px #00000029',
        backgroundColor:'#00AE00',
        cursor:'pointer',
        '& svg':{
            color:'#fff'
        }
    },

    socialIconDiv:{
        width:'68px',
        height:'68px',
        cursor:'pointer',
        "& img":{
            width:'100%',
            height:'100%'
        }
    },

    socialBtns:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center',
        paddingTop:'10px',
        width:'60%',
        alignSelf:'center'
    },

    loginBtn:{
        backgroundColor:'#36ABEF',
        border:'none',
        borderRadius:'50px',
        width:'100%',
        height:'45px',
        fontSize:'24px',
        textAlign:'center',
        marginTop:'28px',
        color:'#fff',
        fontWeight:'bold',
        cursor:'pointer'
    },

    teamLoginBtn:{
        backgroundColor:'#EDEDED',
        border:'none',
        borderRadius:'8px',
        minWidth:'200px',
        width:'200px',
        height:'30px',
        fontSize:'14px',
        textAlign:'center',
        marginTop:'28px',
        color:'#003E93',
        cursor:'pointer',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        transition:'all 0.4s ease',

        '&:hover':{
            opacity:0.7
        }
    },

    ml_20:{
        marginLeft: '20px'
    },

    mr_20:{
        marginRight: '20px'
    },

    compName:{
        fontSize:'36px',
        textTransform: 'capitalize',
        color: '#000',
        fontWeight: 'bold',
        padding: '12px 0px 18px 0px',
    },

    termCheckDiv:{
        display:'flex',
        flexDirection:'row',
        flexWrap:'wrap',
        alignItems:'flex-start',
        justifyContent:'center',
        margin:'10px 0px',
        [theme.breakpoints.down('md')]: {
            flexWrap:'nowrap !important'
        }
    },

    termSpan:{
        // fontFamily: "'Poppins', sans-serif",
        color:'#000',
        fontSize:'15px',
        'a':{
            fontWeight:'bold',
            fontSize:'20px'
        },
        [theme.breakpoints.down('md')]: {
            textAlign:'center !important'
        }
    },
});

class Login extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            showCodeForm:false,
            checkingCode:false,
            code:'',
            showSocial:false,
            showRegisterForm:false,
            avatar:'',
            avatarUrl:'',
            firstName:'',
            lastName:'',
            notificationToken:'',
            parentRelation:'',
            isRegister:false,
            altCountryCode:'SA',
            alternativeNumber:'',
            whatsappNumber:'',
            phoneAuth:false,
            emailDialog:false,
            currentUserId:'',
            currentUserData:{},
            showForget:false,
            forgetSuccess:false,
            //  login
            email:'',
            password:'',
            pwdVisible:false,
            // phone
            phoneAuthentication:false,
            showPhoneAuth:false,
            countryCode:'SA',
            mobileNumber:'',
            // signup
            signupEmail:'',
            signupPassword:'',
            agree:false,
            totalCustomers:0,
            thirdPartyLoader:false
        }
        this.googleProvider = new firebase.auth.GoogleAuthProvider();
        this.facebookProvider = new firebase.auth.FacebookAuthProvider();
    }

    // reset all state
    resetState = () =>{
        this._isMounted = true;
        if(this._isMounted) {
            this.setState({showCodeForm:false,checkingCode:false,showSocial:false,showRegisterForm:false,isRegister:false,phoneAuth:false,code:'',avatarUrl:'',agree:false,
            firstName:'',lastName:'',email:'',avatar:'',notificationToken:'',parentRelation:'',countryCode:'SA',mobileNumber:''})
        }
    }

    async componentDidMount() {
        this._isMounted = true;
        this.getIpAddressData();

        this.getTotalCustomer();

        if(this._isMounted) {
            if(!this.props.user) {
                this.logout();
            };
            window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container', {
                'size': 'invisible',
                'callback': function() {
                    this.registerParent();
                },
                'expired-callback': response => {
                    // Response expired. Ask user to solve reCAPTCHA again.
                    this.props.showAlert('Recaptcha Expired. Please try again.','error');
                }
            });

            const permissionStatus = await navigator?.permissions?.query({name: 'geolocation'})
            const hasPermission = permissionStatus?.state;

            if(hasPermission === 'denied') {
                this.getIpAddressData();
            }
            else{
                this.getCurrentLocation();
            };
        }
    }

    getCurrentLocation = async () => {
        navigator.geolocation.getCurrentPosition((location)=>{
            var lat = location.coords.latitude;
            var long = location.coords.longitude;
            if(lat && long) {
                this.getCityCountry(lat,long);
            } 
        })
    };

    getTotalCustomer = async () => {
        const { company } = this.props;
        const companyId = company?.id;
        if(companyId) {
            getCompanyTotalCustomers({companyId})
            .then(res=> {
                this.setState({totalCustomers:res})
            })
            .catch(e=> {
                console.log('get total customer error',e)
            })
        }
    };

    getIpAddressData= async () => {
        const data = await getIpAddress();
        if(data) {
            this.setState({countryCode:data.country_code2,altCountryCode:data?.country_code2});
        }
    };

    getCityCountry = (lat,long) => {
        Geocode.setApiKey(process.env.REACT_APP_GOOGLE_API);
        if(lat && long) {
            Geocode.fromLatLng(lat, long).then(
                ({results,status}) => {
                    var country = ''
                    var countryCode='';
                    if (results[1]) {
                        
                        for (var r = 0, rl = results.length; r < rl; r += 1) {
                            var result = results[r];
                           
                            if (!country && result.types[0] === 'country') {
                                countryCode = result.address_components[0].short_name;
                            };
            
                            if (countryCode) {
                                break;
                            }
                        };
                    }
                    this.setState({countryCode:countryCode,altCountryCode:countryCode});
                },
                error => {
                console.error(error);
                }
            );
        }
    }

    getIpAddress = async () => {
        this._isMounted = true;
        if(this._isMounted) {
            try{
                const {data} = await axios.get(`${ipgeoURL}${ipgeoApikey}`);
                if(data && data.country_code2) {
                    const parentLocation = {city: data.city, countryCode: data.country_code2, address: ''};
                    this.props.saveParentLocation(parentLocation);
                    this.setState({countryCode:data.country_code2});
                }
            }
            catch(e){
                console.log('getIpAddress error',e)
            }
        }
    };

    async componentWillUnmount() {
        this.resetState();
        this._isMounted = false;
    }

    // login parent event for phone auth
    loginParent = () => {
        this._isMounted = true;
        const { t,showAlert } = this.props;
        let {mobileNumber,email} = this.state;
        if(!isValidPhoneNumber(mobileNumber) && this._isMounted) {
            showAlert(t('booking.login_section.validation.msg'),'error');
        }
        else{
            if(this._isMounted) {
                this.setState({phoneAuth:true,loading:true});
                mobileNumber = formatPhoneNumberIntl(mobileNumber);
                this.props.set_parentEmail(email);
                var appVerifier = window.recaptchaVerifier;
                firebase.auth().signInWithPhoneNumber(mobileNumber, appVerifier)
                .then((confirmationResult)=> {
                    window.confirmationResult = confirmationResult;
                    if(this._isMounted) this.setState({showCodeForm:true,loading:false});
                })
                .catch((error)=> {
                    console.log('error',error);
                    if(error.message === "We have blocked all requests from this device due to unusual activity. Try again later." && this._isMounted) {
                        this.setState({phoneAuth:false,showSocial:true},()=>  {
                            if(this.props.loginDialog) this.props.errorEvent(error.message)
                            else{
                                showAlert(error.message,'error');
                            }
                        })
                    }
                    else{
                        if(this.props.loginDialog) this.props.errorEvent(error.message)
                        else{
                            showAlert(error.message,'error');
                            this.setState({phoneAuth:false});
                        }
                    }
                    this.setState({loading:false})
                });
            }
        }
    }

    // verify verification code
    submitPhoneNumberAuthCode = () => {
        this._isMounted = true;
        let{code,firstName,lastName,mobileNumber,countryCode,email,notificationToken,parentRelation,avatar}= this.state;
        const { showRegisterEvent,increaseStep,t,showAlert, history } = this.props;
        
        if(!code && this._isMounted) {
            showAlert(t('booking.login_section.validation.msg2'),'error');
        }
        else{
            if(this._isMounted) this.setState({checkingCode:true,loading:true});
            window.confirmationResult.confirm(code)
            .then((result)=> {
                let uid = result.user.uid;
                let isNewUser = result.additionalUserInfo.isNewUser;
                let _mobileNumber = formatPhoneNumberIntl(mobileNumber);
                _mobileNumber = _mobileNumber.replace(/\s/g,'');
                let object = {firstName,lastName,email,mobileNumber:_mobileNumber,countryCode,notificationToken,parentRelation,avatar};
                object.id = uid;
                if(!isNewUser) {
                    db.ref(`Users/${uid}`).once('value',async (data)=> {
                        var userData = data.val();
                        if(userData && this._isMounted) {
                            userData.isParent = true;
                            this.storeSession(uid);
                            this.props.store_user(userData);
                            this.props.successMsgEvent(t('booking.login_section.validation.msg3'));
                            increaseStep(1);
                            this.setState({loading:false});
                            setTimeout(()=> history.push('/dashboard'),1000);
                        }
                        else{
                            if(this._isMounted) this.setState({showRegisterForm:true,showPhoneAuth:false,showCodeForm:false,loading:false,phoneAuthentication:true,currentUserId:uid},() => showRegisterEvent());
                        }
                    })
                    .catch(e=> {
                        console.log('errr',e)
                        if(this._isMounted) {
                            showAlert(e.message,'error');
                            this.setState({checkingCode:false,loading:false});
                        } 
                    })
                }
                else{
                    if(this._isMounted) this.setState({showRegisterForm:true,showCodeForm:false,showPhoneAuth:false,phoneAuthentication:true,loading:false,currentUserId:uid},() => showRegisterEvent());
                }
            })
            .catch((error)=> {
                console.log('phone auth error====>',error);
                // if(error && error['message'].indexOf( 'IDBDatabase' ) !== 1) {
                //     window.location.reload();
                // }
                if(this._isMounted) {
                    showAlert(error.message,'error');
                    this.setState({checkingCode:false,showSocial:true,loading:false});
                }
            });
        }
    };

    emailLogin = async () => {
        let {email,password} = this.state;
        const { t, increaseStep, showAlert, company, openPinDialog, saveParentTempInfo, location, history } = this.props;
        const _companyId = company?.id || '';
        const { enableLoginVerification } = company || {};
        const redirectUrl = location.search.slice(1).split("&")[0].split("=")[1];
        const param2 = location.search.slice(1).split("&")[0].split("=")[2];
            
        var searchParams = new URLSearchParams(window.location.search);
        var customerIdSearchQuery = searchParams.get('cId');

        if(!email_patt.test(email)) {
            showAlert(t('new_company.alert_msg.vv-email'),'error');
        }
        else if(password.length < 6) {
            showAlert('Password length atleast 6','error');
        }
        else{
            this.setState({loading:true});
            password = password.trim();
            var login = parentLogin(email,password)
            login.then(async data=> {
                if(data) {
                    if(enableLoginVerification) {
                        saveParentTempInfo({email,uid:data?.id});
                        generateSigninOTP({email,userId:data?.id,companyId:_companyId})
                        .then(()=> {
                            this.setState({loading:false});
                            openPinDialog();
                        })
                        .catch(e=> {
                            showAlert(e,'error')
                        })
                    }
                    else{
                        data.isParent = true;
                        this.storeSession(data?.id);
                        this.props.store_user(data);
                        this.props.set_parentEmail(data?.email); // set parent email in localstorage
                        this.props.successMsgEvent(t('booking.login_section.validation.msg3'));
                        increaseStep(1);
                        this.setState({thirdPartyLoader:false});
                        if(customerIdSearchQuery) {
                            setTimeout(()=>history.push('/dashboard'),1000);
                        }
                        else{
                            setTimeout(()=> history.push(`/${param2 && redirectUrl ? `${redirectUrl}=${param2}` : redirectUrl ? redirectUrl : 'dashboard'}`),1000);
                        };
                    }
                }
                else{
                    if(this._isMounted) {
                        showAlert('No accont found','error');
                        this.setState({loading:false},()=> auth.signOut());
                    } 
                }
            })
            .catch(e=> {
                showAlert(e,'error')
                this.setState({loading:false})
                console.log('error========',e)
            })
        }
    };

    // if no account found register user
    registerParent = () => {
        this._isMounted = true;
        let {currentUserId, firstName,lastName,mobileNumber, alternativeNumber,whatsappNumber,signupEmail,signupPassword,countryCode,notificationToken,parentRelation,avatar,avatarUrl, phoneAuthentication, agree} = this.state;
        const { increaseStep,successMsgEvent, openPinDialog, saveParentTempInfo, t, location,showAlert, company, history } = this.props;
        const _companyId = company?.id || '';
        const { enableSignupVerification } = company || {};
        var searchParams = new URLSearchParams(window.location.search);
        var customerIdSearchQuery = searchParams.get('cId');
        const password_patt = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-._]).{8,}$/;

        const redirectUrl = location.search.slice(1).split("&")[0].split("=")[1];
        const param2 = location.search.slice(1).split("&")[0].split("=")[2];
            

        if(!email_patt.test(signupEmail) && this._isMounted) {
            showAlert(t('booking.login_section.validation.msg5'),'error');
        }
        else if(!phoneAuthentication && signupPassword.length < 6) {
            showAlert('Password length atleast 6','error');
        }
        // else if(!phoneAuthentication && !password_patt.test(signupPassword) || signupPassword?.toLowerCase() === 'test.2415') {
        //     showAlert(`Passwords must be at least 8 characters long.\n
        //     Passwords must have at least 1 upper case letter(s).\n
        //     Passwords must have at least 1 non-alphanumeric character(s) such as as *, -, or #.`,'error');
        // }
        else if(!firstName && this._isMounted) {
            showAlert(t('booking.dialog.validation.fName'),'error');
        }
        else if(!lastName && this._isMounted) {
            showAlert(t('booking.dialog.validation.lName'),'error');
        }
        else if(!phoneAuthentication && !isValidPhoneNumber(mobileNumber) && this._isMounted) {
            showAlert(t('booking.login_section.validation.msg4'),'error');
        }
        else if(phoneAuthentication && alternativeNumber && !isValidPhoneNumber(alternativeNumber) && this._isMounted) {
            showAlert(t('booking.login_section.invalidAltNum'),'error');
        }
        else if(!agree && this._isMounted) {
            showAlert(t('getStarted.alert.three'),'error')
        }
        else{
            if(this._isMounted) this.setState({isRegister:true,loading:true});

            let _mobileNumber = formatPhoneNumberIntl(mobileNumber);
            _mobileNumber = _mobileNumber.replace(/\s/g,'');
            alternativeNumber = formatPhoneNumberIntl(alternativeNumber);
            alternativeNumber = alternativeNumber.replace(/\s/g,'');

            whatsappNumber = formatPhoneNumberIntl(whatsappNumber);
            whatsappNumber = whatsappNumber.replace(/\s/g,'');

            let object = {firstName,lastName,avatar:'',email:signupEmail,mobileNumber:_mobileNumber,'alternativeNumber': alternativeNumber ? alternativeNumber : null,whatsappNumber: whatsappNumber ? whatsappNumber : null,countryCode,notificationToken,parentRelation,lang:'en',...(customerIdSearchQuery ? {customerId:customerIdSearchQuery} : {_companyId})};

            if(phoneAuthentication) {
                // let currentUser = firebase.auth().currentUser
                // let uid = currentUser && currentUser.uid;
                object.id = currentUserId;
                this.props.set_parentEmail(signupEmail); // set parent email in localstorage
                db.ref(`Users/${currentUserId}`).set(object)
                .then(() => {
                    object.isParent = true;
                    this.props.store_user(object);
                    this.storeSession(currentUserId);
                    increaseStep(1);
                    this.setState({loading:false});
                    successMsgEvent(t('booking.login_section.validation.msg6'));

                    if(customerIdSearchQuery) {
                        setTimeout(()=>history.push('/dashboard'),1000);
                    }
                    else{
                        setTimeout(()=> history.push(`/${param2 && redirectUrl ? `${redirectUrl}=${param2}` : redirectUrl ? redirectUrl : 'dashboard'}`),1000);
                    };
                })
                .catch(e=> {
                    console.log('errr',e)
                    if(this._isMounted)  {
                        showAlert(e.message,'error');
                        this.setState({isRegister:false,loading:false});
                    }
                })
            }
            else{
                if(enableSignupVerification) {
                    sendSignupOtp({email:signupEmail,companyId:_companyId})
                    .then((signupOtpRes)=> {
                        if(signupOtpRes?.otp) {
                            const depOtp = signupOtpRes?.otp ? Number(CryptoJS.AES.decrypt(signupOtpRes?.otp, passHashSecret).toString(CryptoJS.enc.Utf8)) : null;
                            const encryptPwd = CryptoJS.AES.encrypt(String(signupPassword || ""), passHashSecret).toString();
                            const expiry = CryptoJS.AES.encrypt(String(signupOtpRes?.expirationTimestamp || ""), passHashSecret).toString();
                            const encryptedObject = CryptoJS.AES.encrypt(JSON.stringify(object), passHashSecret).toString();
                            this.setState({loading:false});
                            openPinDialog();
                            // s_pso = signup parent otp, s_pso_ex = signup parent otp expiry, si_up = indicate signup user, sd = signup data, en_ps = encrypt password
                            const parInfo = {email:signupEmail,'s_pso':signupOtpRes?.otp,'s_pso_ex':expiry,'si_up':true,'sd': encryptedObject,'en_ps':encryptPwd};
                            saveParentTempInfo(parInfo);
                        }
                    })
                    .catch(e=> {
                        showAlert(e,'error')
                        this.setState({loading:false});
                    })
                }
                else{
                    const signupEvent = parentSignup(object,signupEmail,signupPassword)
                    signupEvent.then(nodeId => {
                            object.id = nodeId;
                            object.isParent = true;
                            this.storeSession(nodeId);
                            this.props.set_parentEmail(signupEmail); // set parent email in localstorage
                            this.props.store_user(object);
                            increaseStep(1);
                            this.setState({loading:false})
                            successMsgEvent(t('booking.login_section.validation.msg6'));

                            if(customerIdSearchQuery) {
                                setTimeout(()=>history.push('/dashboard'),1000);
                            }
                            else{
                                setTimeout(()=> history.push(`/${param2 && redirectUrl ? `${redirectUrl}=${param2}` : redirectUrl ? redirectUrl : 'dashboard'}`),1000);
                            };
                        
                    })
                    .catch(err=> {
                        console.log('errr',err)
                        if(this._isMounted) {
                            showAlert(err,'error');
                            this.setState({isRegister:false,loading:false});
                        } 
                    })
                }
            }
        }
    }

    // Google login
    googleLogin = () => {
        this._isMounted = true;
        let{firstName,lastName,mobileNumber,countryCode,email,notificationToken,parentRelation,avatar, totalCustomers}= this.state;
        const { increaseStep, successMsgEvent, t,location,showAlert, company, history, planId, plans } = this.props;
        const _companyId = company?.id || '';
        var searchParams = new URLSearchParams(window.location.search);
        var customerIdSearchQuery = searchParams.get('cId');
        this.setState({thirdPartyLoader:true});
        const redirectUrl = location.search.slice(1).split("&")[0].split("=")[1];
        const param2 = location.search.slice(1).split("&")[0].split("=")[2];
        const customerLimit = plans['customers'][planId];
            
        var searchParams = new URLSearchParams(window.location.search);
        var customerIdSearchQuery = searchParams.get('cId');
        firebase.auth().signInWithPopup(this.googleProvider).then(result => {
            // The signed-in user info.
            var user = result.user;
            let uid = user.uid;
            let displayName = user.displayName;
            displayName = displayName.split(' ');
            firstName = displayName[0] ? displayName[0] : firstName;
            lastName = displayName[1] ? displayName[1] : lastName;
            mobileNumber = user.phoneNumber ? user.phoneNumber : formatPhoneNumberIntl(mobileNumber).replace(/\s/g,'');
            email = user.email ? user.email : email;

            avatar = user.photoURL ? user.photoURL : avatar;

            let object = {firstName,lastName,email,mobileNumber,countryCode,avatar,notificationToken,parentRelation,id:uid,lang:'en',...(customerIdSearchQuery ? {customerId: customerIdSearchQuery} : {_companyId})};
            if(!result.additionalUserInfo.isNewUser) {
                db.ref(`Users/${uid}`).once('value',(data)=> {
                    var userData = data.val();
                    if(userData) {
                        if(!userData.email || !userData.mobileNumber) {
                            this.emailDialogOpen();
                            this.setState({currentUserId:uid,currentUserData:userData,thirdPartyLoader:false})
                        }
                        else if(userData.email && userData.mobileNumber){
                            userData.isParent = true;
                            this.storeSession(uid);
                            this.props.store_user(userData,'ff5');
                            successMsgEvent(t('booking.login_section.validation.msg3'));
                            increaseStep(1);
                            this.setState({thirdPartyLoader:false})
                            if(customerIdSearchQuery) {
                                setTimeout(()=>history.push('/dashboard'),1000);
                            }
                            else{
                                setTimeout(()=> history.push(`/${param2 && redirectUrl ? `${redirectUrl}=${param2}` : redirectUrl ? redirectUrl : 'dashboard'}`),1000);
                            };
                        }
                    }
                    else{
                        if(!email || !mobileNumber) {
                            if(totalCustomers >= customerLimit && customerLimit !== 'unlimited') {
                               this.setState({thirdPartyLoader:false});
                                showAlert(t('booking.login_section.validation.signupUnable'),'error')
                            }
                            else{
                                this.emailDialogOpen();
                                this.setState({currentUserId:uid,currentUserData:object,thirdPartyLoader:false})
                            }
                        }
                        else{
                            if(totalCustomers >= customerLimit && customerLimit !== 'unlimited') {
                               this.setState({thirdPartyLoader:false});
                                showAlert(t('booking.login_section.validation.signupUnable'),'error')
                            }
                            else{
                                db.ref(`Users/${uid}`).set(object)
                                .then(() => {
                                    object.isParent = true;
                                    this.storeSession(uid);
                                    this.props.store_user(object);
                                    successMsgEvent(t('booking.login_section.validation.msg6'));
                                    increaseStep(1);
                                    this.setState({thirdPartyLoader:false});
                                    if(customerIdSearchQuery) {
                                        setTimeout(()=>history.push('/dashboard'),1000);
                                    }
                                    else{
                                        setTimeout(()=> history.push(`/${param2 && redirectUrl ? `${redirectUrl}=${param2}` : redirectUrl ? redirectUrl : 'dashboard'}`),1000);
                                    };
                                })
                                .catch(e=> {
                                    console.log('errr',e)
                                    if(this._isMounted) {
                                        showAlert(e.message,'error');
                                        this.setState({checkingCode:false,thirdPartyLoader:false});
                                    } 
                                })
                            }
                        }
                    }
                })
                .catch(e=> {
                    console.log('errr',e)
                    if(this._isMounted) {
                        showAlert(e.message,'error');
                        this.setState({checkingCode:false,thirdPartyLoader:false});
                    } 
                })
            }
            else{
                if(!email || !mobileNumber) {
                    if(totalCustomers >= customerLimit && customerLimit !== 'unlimited') {
                        showAlert(t('booking.login_section.validation.signupUnable'),'error');
                        this.setState({thirdPartyLoader:false})
                    }
                    else{
                        this.emailDialogOpen();
                        this.setState({currentUserId:uid,currentUserData:object,thirdPartyLoader:false})
                    }
                }
                else{
                    if(totalCustomers >= customerLimit && customerLimit !== 'unlimited') {
                        showAlert(t('booking.login_section.validation.signupUnable'),'error');
                        this.setState({thirdPartyLoader:false})
                    }
                    else{
                        db.ref(`Users/${uid}`).set(object)
                        .then(()=> {
                            object.isParent = true;
                            this.storeSession(uid);
                            this.props.store_user(object);
                            successMsgEvent(t('booking.login_section.validation.msg6'));
                            increaseStep(1);
                            this.setState({thirdPartyLoader:false})
                            if(customerIdSearchQuery) {
                                setTimeout(()=>history.push('/dashboard'),1000);
                            }
                            else{
                                setTimeout(()=> history.push(`/${param2 && redirectUrl ? `${redirectUrl}=${param2}` : redirectUrl ? redirectUrl : 'dashboard'}`),1000);
                            };
                        })
                        .catch(e=> {
                            console.log('errr',e)
                            if(this._isMounted) {
                                showAlert(e.message,'error');
                                this.setState({checkingCode:false,thirdPartyLoader:false});
                            } 
                        })
                    }
                }
            }
        }).catch(error => {
            console.log('google error',error)
            if(error && error['message'].indexOf( 'IDBDatabase' ) !== 1) {
                window.location.reload();
            }
            if(this._isMounted) {
                showAlert(error.message,'error');
                this.setState({thirdPartyLoader:false})
            } 
        });
    }

    // Facebook login
    facebookLogin = () => {
        this._isMounted = true;
        let{firstName,lastName,mobileNumber,countryCode,email,notificationToken,parentRelation,avatar}= this.state;
        const { increaseStep, successMsgEvent,t, location, showAlert, company, history } = this.props;
        const _companyId = company?.id || '';
        var searchParams = new URLSearchParams(window.location.search);
        var customerIdSearchQuery = searchParams.get('cId');
        this.setState({thirdPartyLoader:true});
        const redirectUrl = location.search.slice(1).split("&")[0].split("=")[1];
        const param2 = location.search.slice(1).split("&")[0].split("=")[2];
            
        var searchParams = new URLSearchParams(window.location.search);
        var customerIdSearchQuery = searchParams.get('cId');

        firebase.auth().signInWithPopup(this.facebookProvider).then(result => {
            // The signed-in user info.
            var user = result.user;
            let uid = user.uid;
            let displayName = user.displayName;
            displayName = displayName.split(' ');
            firstName = displayName[0] ? displayName[0] : firstName;
            lastName = displayName[1] ? displayName[1] : lastName;
            
            mobileNumber = user.phoneNumber ? user.phoneNumber : formatPhoneNumberIntl(mobileNumber).replace(/\s/g,'');
            email = user.email ? user.email : email;

            avatar = user.photoURL ? user.photoURL : avatar;

            let object = {firstName,lastName,email,mobileNumber,countryCode,avatar,notificationToken,parentRelation,id:uid,lang:'en',...(customerIdSearchQuery ? {customerId:customerIdSearchQuery} : {_companyId})};
            
            if(!result.additionalUserInfo.isNewUser) {
                db.ref(`Users/${uid}`).once('value',(data)=> {
                    var userData = data.val();
                    if(userData) {
                        if(!userData.email || !userData.mobileNumber) {
                            this.emailDialogOpen();
                            this.setState({currentUserId:uid,currentUserData:userData,thirdPartyLoader:false})
                        }
                        else if(userData.email && userData.mobileNumber){
                            userData.isParent = true;
                            this.storeSession(uid);
                            this.props.store_user(userData,'ff8');
                            successMsgEvent(t('booking.login_section.validation.msg3'));
                            increaseStep(1);
                            this.setState({thirdPartyLoader:false});
                            if(customerIdSearchQuery) {
                                setTimeout(()=>history.push('/dashboard'),1000);
                            }
                            else{
                                setTimeout(()=> history.push(`/${param2 && redirectUrl ? `${redirectUrl}=${param2}` : redirectUrl ? redirectUrl : 'dashboard'}`),1000);
                            };
                        }
                    }
                    else{
                        if(!email || !mobileNumber) {
                            this.emailDialogOpen();
                            this.setState({currentUserId:uid,currentUserData:object,thirdPartyLoader:false})
                        }
                        else{
                            db.ref(`Users/${uid}`).set(object)
                            .then(() => {
                                object.isParent = true;
                                this.storeSession(uid);
                                this.props.store_user(object);
                                successMsgEvent(t('booking.login_section.validation.msg6'));
                                increaseStep(1);
                                this.setState({thirdPartyLoader:false});
                                if(customerIdSearchQuery) {
                                    setTimeout(()=>history.push('/dashboard'),1000);
                                }
                                else{
                                    setTimeout(()=> history.push(`/${param2 && redirectUrl ? `${redirectUrl}=${param2}` : redirectUrl ? redirectUrl : 'dashboard'}`),1000);
                                };
                            })
                            .catch(e=> {
                                console.log('errr',e)
                                if(this._isMounted) {
                                    showAlert(e.message,'error');
                                    this.setState({checkingCode:false,thirdPartyLoader:false});
                                }
                            })
                        }
                    }
                })
                .catch(e=> {
                    console.log('errr',e)
                    if(this._isMounted) {
                        showAlert(e.message,'error');
                        this.setState({checkingCode:false,thirdPartyLoader:false});
                    }
                })
            }
            else{
                if(!email || !mobileNumber) {
                    this.emailDialogOpen();
                    this.setState({currentUserId:uid,currentUserData:object,thirdPartyLoader:false})
                }
                else{
                    db.ref(`Users/${uid}`).set(object)
                    .then(() => {
                        object.isParent = true;
                        this.storeSession(uid);
                        this.props.store_user(object);
                        successMsgEvent(t('booking.login_section.validation.msg6'));
                        increaseStep(1);
                        this.setState({thirdPartyLoader:false})
                        if(customerIdSearchQuery) {
                            setTimeout(()=>history.push('/dashboard'),1000);
                        }
                        else{
                            setTimeout(()=> history.push(`/${param2 && redirectUrl ? `${redirectUrl}=${param2}` : redirectUrl ? redirectUrl : 'dashboard'}`),1000);
                        };
                    })
                    .catch(e=> {
                        console.log('errr',e)
                        if(this._isMounted) {
                            showAlert(e.message,'error');
                            this.setState({checkingCode:false,thirdPartyLoader:false});
                        }
                    })
                }
            }
        }).catch(error => {
            console.log('fb error',error)
            if(error && error['message'].indexOf( 'IDBDatabase' ) !== 1) {
                window.location.reload();
            }
            if(this._isMounted) {
                showAlert(error.message,'error');
                this.setState({thirdPartyLoader:false})
            }
        });
    }

    // input onchange event
    onChangeHandle = (fieldName,value) => {
        this.setState({[fieldName]:value})
    };

    storeSession = (uid) => {
        const sessionId = uuidv4();
        const sessionRef = db.ref(`ParentSessions/${uid}/${sessionId}`);
        // Store session in Realtime Database
        sessionRef.set({
            sessionId,
            lastActive: firebase.database.ServerValue.TIMESTAMP,
        });
        // Store the session reference for later removal                    
        this.props.saveSession(`ParentSessions/${uid}/${sessionId}`);
    };

    showSocialEvent = () => {
        this._isMounted = true;
        if(this._isMounted) this.setState({showSocial:true})
    }

    countryEvent = value => {
        this._isMounted = true;
        if(this._isMounted) this.setState({countryCode:value,mobileNumber:''})
    }

    dialogPhoneOnChange = value => {
        this._isMounted = true;
        if(this._isMounted) this.setState({mobileNumber:value})
    }

    altCountryEvent = value => {
        this._isMounted = true;
        if(this._isMounted) this.setState({altCountryCode:value,alternativeNumber:'',whatsappNumber:''})
    }

    phoneOnChange = (value,fieldName) => {
        this._isMounted = true;
        if(this._isMounted) this.setState({[fieldName]:value})
    }

    emailDialogClose = () => {
        this._isMounted = true;
        if(this._isMounted) this.setState({emailDialog:false});
    }

    emailDialogOpen = () => {
        this._isMounted = true;
        if(this._isMounted) this.setState({emailDialog:true});
    }

    onchangeInput = (fieldName,value) => {
        this._isMounted = true;
        if(this._isMounted) this.setState({[fieldName]:value})
    }

    updateEmailPhone = () => { // update email and mobile number if not found
        this._isMounted = true;
        let{mobileNumber,email,currentUserId,currentUserData}= this.state;
        const { increaseStep, successMsgEvent, t,showAlert, history } = this.props;
        if(this._isMounted) {
            if(!currentUserId) {
                showAlert('No user found to update','error');
            }
            if(!email_patt.test(email)) {
                showAlert('Provide valid email','error');
            }
            else if(!mobileNumber || !isValidPhoneNumber(mobileNumber)) {
                showAlert(t('booking.login_section.validation.msg'),'error');
            }
            else if(currentUserId){
                currentUserData.mobileNumber = formatPhoneNumberIntl(mobileNumber).replace(/\s/g,'');
                currentUserData.email = email;
                db.ref(`Users/${currentUserId}`).set(currentUserData)
                .then(()=> {
                    currentUserData.isParent = true;
                    this.props.store_user(currentUserData);
                    successMsgEvent(t('booking.login_section.validation.msg6'));
                    increaseStep(1);
                    setTimeout(()=> history.push('/dashboard'),1000);
                })
                .catch(e=> {
                    console.log('errr',e)
                    if(this._isMounted) {
                        showAlert(e.message,'error');
                        this.setState({checkingCode:false});
                    }
                })
            }
        }
    };

    _visiblePwd = () => {
        const {pwdVisible} = this.state;
        this.setState({pwdVisible:!pwdVisible})
    };

    showEmailForm = () => {
        this.setState({showCodeForm:false,showPhoneAuth:false,mobileNumber:'',code:'',email:'',password:'',signupEmail:'',signupPassword:'',firstName:'',lastName:'',whatsappNumber:'',alternativeNumber:'',checkingCode:false,showRegisterForm:false,showSocial:false,showForget:false,forgetSuccess:false})
    };

    backEvent = () => {
        const { showCodeForm, checkingCode } = this.state;
        if(showCodeForm) {
            this.setState({checkingCode:false,showCodeForm:false,mobileNumber:'',code:'',showSocial:false})
        }
        else if(checkingCode){
            this.setState({checkingCode:false,code:'',showSocial:false})
        }
        else{
            this.setState({showCodeForm:false,showPhoneAuth:false,mobileNumber:'',code:'',email:'',password:'',signupEmail:'',signupPassword:'',firstName:'',lastName:'',whatsappNumber:'',alternativeNumber:'',checkingCode:false,showRegisterForm:false,showSocial:false,showForget:false,forgetSuccess:false,agree:false})
        }
        // this.logout();
    };

    submitEvent = e => {
        const { showPhoneAuth, showCodeForm, showRegisterForm, showForget, totalCustomers } = this.state;
        const { planId, plans, showAlert } = this.props;
        const customerLimit = plans['customers'][planId];

        e.preventDefault();
        if(showCodeForm) {
            this.submitPhoneNumberAuthCode()
        }
        else if(showPhoneAuth) {
            this.loginParent();
        }
        else if(showRegisterForm){
            if(totalCustomers >= customerLimit && customerLimit !== 'unlimited') {
                showAlert('Unable to signup Please contact support','error');
            }
            else{
                this.registerParent();
            }
        }
        else if(showForget){
            this.forgetPassEvent();
        }
        else{
            this.emailLogin();
        }
    };

    logout = () => {
        firebase.auth().signOut();
        this.props.logout_user();
    };

    forgetPassEvent = () => {
        const {email} = this.state;
        const { t, showAlert, company } = this.props;
        const email_patt = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if(!email_patt.test(email)) {
            showAlert(t('new_company.alert_msg.vv-email'),'error');
        }
        else{
            this.setState({loading:true});
            const uniqueName = company && company?.urlName ? company?.urlName : company?.id;
            const link = window.location.host !== 'my.selynk.com' ? `https://${window.location.host}/login` : `https://my.selynk.com/login/${uniqueName}`
            var actionCodeSettings = {
                url: link,
                handleCodeInApp: true
            };
            firebase.auth().sendPasswordResetEmail(email,actionCodeSettings)
            .then(()=> {
                showAlert('Please check your email.','info');
                this.setState({email:'',forgetSuccess:true,loading:false})
            }).catch((e)=> {
                showAlert(e.message,'error');
                this.setState({loading:false})
                console.log(e)
            })
        }
    }

    render() {
    let {emailDialog,showCodeForm,checkingCode,code,showSocial,showRegisterForm,firstName,lastName,email,thirdPartyLoader,
    password,loading,countryCode,mobileNumber, alternativeNumber,whatsappNumber,altCountryCode,pwdVisible,
    showPhoneAuth, signupEmail, signupPassword,phoneAuthentication,showForget, forgetSuccess, totalCustomers} = this.state;
    let {classes, isLogin,t,i18n, company, planId, plans } = this.props;
    const companyId = company && company?.urlName ? company?.urlName : company?.id || '';
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;

    const googleAuthenicationEnable = company && company?.googleAuthenicationEnable !== undefined ? company?.googleAuthenicationEnable : true;
    const loginList = [
        {label:t('companyPage.email'),value:email,type:'email',id:'email',placeholder:'email@email.com'},
        {label:t('update-password.pass'),value:password,type: pwdVisible ? 'text' : 'password',id:'password',placeholder:'******'},
    ];
    const registerList = [
        {label:t('companyPage.email'),value:signupEmail,type:'email',id:'signupEmail',placeholder:'email@email.com'},
        {label:t('update-password.pass'),value:signupPassword,type: pwdVisible ? 'text' : 'password',id:'signupPassword',placeholder:'******',disable:phoneAuthentication},
        {label:t('profile-comp.first'),value:firstName,type: 'text', id:'firstName',placeholder:t('profile-comp.first')},
        {label:t('profile-comp.last'),value:lastName,type: 'text', id:'lastName',placeholder:t('profile-comp.last')},
        {label:t(phoneAuthentication ? 'booking.login_section.altNum' : 'comp-comp.ph-place'),countryCode: phoneAuthentication ? altCountryCode : countryCode, countryEvent: phoneAuthentication ? this.altCountryEvent : this.countryEvent, value: phoneAuthentication ? alternativeNumber : mobileNumber, id: phoneAuthentication ? 'alternativeNumber' : 'mobileNumber', placeholder:t(phoneAuthentication ? 'booking.login_section.altNum' : 'comp-comp.ph-place'),phoneInput:true},
        {label:t('booking.login_section.whatNum'), countryCode: altCountryCode, value:whatsappNumber, id:'whatsappNumber', placeholder:t('booking.login_section.whatNum'),phoneInput:true},
    ];
    const socialList = [
        //     {icon:  <div className={classes.phoneIcon} onClick={()=> this.setState({showPhoneAuth:!showPhoneAuth},()=>this.getLocation())}>
        //             <PhoneOutlined />
        //         </div>
        // },
        {icon:  <div className={classes.socialIconDiv} onClick={this.googleLogin}>
                    <img src={GoogleIcon} alt='google login' />
                </div>
        }
        // {icon: <div className={classes.socialIconDiv} onClick={this.facebookLogin}>
        //             <img src={FbIcon} alt='facebook login' />
        //         </div>
        // }
    ];
    const socialList2 = [
        {icon:  <div className={classes.phoneIcon} onClick={this.showEmailForm}>
                    <EmailOutlined />
                </div>
        },
        {icon:  <div className={classes.socialIconDiv} onClick={this.googleLogin}>
                    <img src={GoogleIcon} alt='google login' />
                </div>
        },
        // {icon: <div className={classes.socialIconDiv} onClick={this.facebookLogin}>
        //             <img src={FbIcon} alt='facebook login' />
        //         </div>
        // }
    ];

    const hostname = window.location.hostname;
    const _companyUrlName = company ? company?.urlName || company?.id : '';
    const urls = ['localhost','my.selynk.com'];
    const termsUrl = urls.includes(hostname) ? `${window.location.origin}/${_companyUrlName}/temp/terms` : `${window.location.origin}/temp/terms`;
    const privacyUrl = urls.includes(hostname) ? `${window.location.origin}/${_companyUrlName}/temp/privacy` : `${window.location.origin}/temp/privacy`;

    return(
        <>
            <form onSubmit={this.submitEvent} className={classes.mainDiv} autoComplete="disabled">
                <span className={classes.compName}>{showForget ? t('parentDashboard.login.resetPassword') : t(`companyPage.${showRegisterForm ? 'signup' : 'signin'}`)}</span>
                
                {/* login via email/pwd */}
                {showPhoneAuth ?
                <>
                {!showCodeForm ?
                    <span style={{color:'#000000',fontSize:'14px',textAlign:'center',padding:'30px 0px 19px 0px'}}>{t('parentDashboard.login.phoneDesc')}</span>
                :
                    <span style={{color:'#000000',fontSize:'14px',textAlign:'center',padding:'30px 0px 19px 0px'}}>{t('parentDashboard.login.codeDesc',{number:mobileNumber})}</span>
                }

                <span className={classes.inputLabel} style={{textAlign: showCodeForm ? 'center' : 'unset',paddingBottom: showCodeForm ? '32px' : 'unset'}}>{t(showCodeForm ? 'booking.login_section.verInput' : 'comp-comp.ph-place')}</span>
                {showCodeForm ?
                    <>
                        <Input {...{className:`${classes.inputCl} ${classes.inputClCode}` ,type:'number',value:code,id:'code',onChange:this.onChangeHandle,placeholder:'123456'}}/>
                        <span className={classes.forgetBtn} style={{cursor:'pointer',alignSelf:'flex-end',paddingTop:'29px'}} onClick={()=> this.setState({showSocial:true})}>{t('booking.login_section.verTitle2')}</span>
                        {showSocial && !isLogin && googleAuthenicationEnable ?
                            <>
                            <span className={classes.inputLabel} style={{paddingTop:'52px'}}>{t('booking.login_section.op')}</span>
                            <div className={classes.socialBtns}>
                                {React.Children.toArray(socialList2.map(v=> {
                                    return v.icon
                                }))}
                            </div>
                            </>
                        : null }
                    </>
                :
                    <PhoneInput
                        placeholder={t('booking.login_section.phoneNum')}
                        defaultCountry={countryCode}
                        value={mobileNumber}
                        // style={{fontFamily}}
                        onChange={(value) => this.phoneOnChange(value,'mobileNumber')}
                        onCountryChange={this.countryEvent}
                        error={mobileNumber ? (isValidPhoneNumber(mobileNumber) ? undefined : t('booking.login_section.invalidNum')) : t('booking.login_section.phoneReq')}
                    />
                }
                </>
                :
                showRegisterForm ?
                <>
                    {React.Children.toArray(registerList.map(v=> {
                        return v.phoneInput ? 
                        (
                        <>
                            <span className={classes.inputLabel}>{v?.label}</span>
                            <PhoneInput
                                placeholder={v?.placeholder}
                                defaultCountry={v?.countryCode}
                                value={v?.value}
                                // style={{fontFamily}}
                                onChange={(value) => this.phoneOnChange(value,v?.id)}
                                onCountryChange={v?.countryEvent}
                                error={v?.value ? (isValidPhoneNumber(v?.value) ? undefined : t('booking.login_section.invalidNum')) : t('booking.login_section.phoneReq')}
                            />
                        </>
                        )
                        :
                        !v?.disable ?
                        (
                            <>
                                <span className={classes.inputLabel} style={{display:v?.disable ? 'none' : ''}}>{v?.label}</span>
                                <Input {...{className:`${classes.inputCl}`,customStyle:{display:v?.disable ? 'none' : ''} ,type:v?.type,value:v?.value,id:v?.id,_visiblePwd:this._visiblePwd,onChange:this.onChangeHandle,isRTL,placeholder:v?.placeholder}}/>
                            </>
                        )
                        : null
                    }))}

                    <div className={classes.termCheckDiv}>
                        <StyleCheckbox checked={this.state.agree} onChange={e => this.setState({agree:e.target.checked})} id='agree' />
                        <span className={classes.termSpan}>{t('getStarted.accept')} <b><a href={termsUrl} rel="noopener noreferrer" target="_blank" style={{color:'#36ABEF'}}>{t('getStarted.terms')}</a></b> and <b><a href={privacyUrl} rel="noopener noreferrer" target="_blank" style={{color:'#36ABEF'}}>{t('getStarted.privacyPolicy')}</a></b></span>
                    </div>
                </>
                :
                showForget ?
                <>
                    {forgetSuccess ?
                        <Alert severity="info" style={{fontSize:'14px',textAlign:'center',margin:'30px 0px 19px 0px'}}>
                            {t('parentDashboard.login.forgetSuccess')}
                        </Alert>
                    :
                    <>
                        <span className={classes.inputLabel}>{t('companyPage.email')}</span>
                        <Input {...{className:`${classes.inputCl}` ,type:'email',value:email,id:'email',onChange:this.onChangeHandle,isRTL,placeholder:t('companyPage.email')}}/>
                    </>
                    }
                </>
                :
                <>
                {React.Children.toArray(loginList.map(v=> {
                    return(<>
                        <span className={`${classes.inputLabel} ${classes.padTop}`}>{v?.label}</span>
                        <Input {...{className:`${classes.inputCl}` ,type:v?.type,value:v?.value,id:v?.id, _visiblePwd:this._visiblePwd,onChange:this.onChangeHandle,isRTL,placeholder:v?.placeholder}}/>
                    </>)
                }))}

                <span className={classes.forgetBtn} style={{cursor:'pointer',alignSelf:'flex-end',paddingTop:'10px'}} onClick={()=> window.open(`https://my.selynk.com/reset-password/${companyId}`,'_blank')}>{t('parentDashboard.login.forgetPwd')}</span>
                {googleAuthenicationEnable ?
                <>
                <span className={classes.darkSpan} style={{fontSize:'14px',paddingTop:'10px'}}>{t('parentDashboard.login.otherMethod')}</span>
                <div className={classes.socialBtns}>
                    {React.Children.toArray(socialList.map(v=> {
                        return v.icon
                    }))}
                </div>
                </>
                : null}
                </>
                }
                
                {!forgetSuccess ?
                    <button className={classes.loginBtn} style={{fontFamily:'inherit',pointerEvents:loading ? 'none' : '', cursor: loading ? 'not-allowed' : 'pointer'}} onClick={this.submitEvent}>
                        {loading ?
                            <DotLoader />
                        :
                        showCodeForm ?
                            checkingCode ? 
                                t('booking.login_section.verBtn') 
                        : 
                            t('booking.login_section.verBtn2')
                        : showRegisterForm ?
                            t('parentDashboard.login.createAccount')
                        : showForget ?
                            t('parentDashboard.login.resetPassword')
                        : t('parentDashboard.login.login')
                        }
                    </button>
                : null }
                {!showPhoneAuth && !showRegisterForm && !showForget ?
                    <div className={classes.forgetBtn} style={{textAlign:'center',paddingTop:'21px'}}>
                        {t('parentDashboard.login.noAccount')}
                        <span style={{fontSize:'24px',fontWeight:'bold',cursor:'pointer'}}
                        onClick={()=> this.setState({showRegisterForm:true})}
                        className={isRTL === 'ar' ? classes.mr_20 : classes.ml_20}>
                            {t('parentDashboard.login.signup')}
                        </span>
                    </div>
                :
                    <span className={classes.forgetBtn} style={{cursor:'pointer',alignSelf:'center',paddingTop:'33px'}} onClick={this.backEvent}>{t('parentDashboard.login.goback')}</span>
                }

                {!forgetSuccess && !showRegisterForm ?
                    <button className={classes.teamLoginBtn} style={{fontFamily:'inherit',pointerEvents:loading ? 'none' : '', cursor: loading ? 'not-allowed' : 'pointer'}} onClick={()=> this.props.history.push('/administration')}>
                        <AccountCircleOutlined style={{color:'#79889b'}}/>
                        <span style={isRTL === 'ar' ? {paddingRight:'10px'} : {paddingLeft:'10px'}}>{t('parentDashboard.login.teamLogin')}</span>
                    </button>
                : null}
            </form>

            <Backdrop className={classes.backdrop} open={thirdPartyLoader}>
                <ColorCircularProgress />
            </Backdrop>

            {/* email & phone number dialog */}
            <EmailPhoneDialog 
                {...{open:emailDialog,mobileNumber,email,countryCode,onChange:this.onchangeInput,onClose:this.emailDialogClose,
                phoneonChange:this.dialogPhoneOnChange,
                countryonChange:this.countryEvent,
                submitHandle:this.updateEmailPhone}}
            />
            {/* recaptcha */}
            <div id="recaptcha-container"></div>
        </>
    )}
}

const mapStateToProps = state => {
    return {
        isLogin: state.isLogin,
        parentLocation: state.parentLoc,
        company: state.company,
        planId: state.planId,
        plans: state.plans
    }
};

const mapDispatchToProps = dispatch => {
    return {
        store_user : (user) => dispatch(save_user(user)),
        set_parentEmail : email => dispatch(set_pm(email)),
        saveParentLocation : data => dispatch(set_parentLocation(data)),
        logout_user : () => dispatch(remove_user()),
        saveSession : (data) => dispatch(saveParentCurrentSession(data)),
        saveParentTempInfo: data => dispatch(setParentTempInfo(data)),
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withTranslation('common')(Login))));
